import moment from "moment";
import { getDeviceInfo } from "../utils/Utils";

const deviceInfo = getDeviceInfo();
export const IGNORE_COMMAND_MS = 1000;
export const DEFAULT_MQTT_PLAY_CONTENT = {
	contentId: -1,
	created: moment.min(moment()).valueOf(),
	deviceId: deviceInfo.deviceId ?? "",
	duration: 0,
	playSessionId: "",
	position: 0,
	screenId: deviceInfo.screenId ?? "",
	state: "stopped",
	vamId: 0,
};
